import React from 'react'
import { SafeAreaView } from 'react-native-safe-area-context'
import styled from 'styled-components/native'
import { ResponsiveScrollView, ResponsiveView } from 'APP/Converse/Layout'
import LogoHeader from 'APP/Components/LogoHeader'
import { Images } from 'APP/Themes'

const ScreenContainer = styled(SafeAreaView)`
  flex: 1;
`

const ContentContainer = styled(ResponsiveView)`
  gap: ${({ theme }) => theme.metrics.baseMargin * 2}px;
  margin-top: ${({ theme }) => theme.metrics.baseMargin * 3}px
  padding: ${({ theme }) => theme.metrics.baseMargin}px;
`

interface OnboardingScreenProps {
  title: string
  subtitle: string
  children: React.ReactNode
}

const OnboardingScreen = ({ title, subtitle, children }: OnboardingScreenProps) => {
  return (
    <ScreenContainer>
      <ResponsiveScrollView alwaysBounceVertical={false} keyboardShouldPersistTaps="always">
        <ContentContainer>
          <LogoHeader source={Images.logoBlue} title={title} subtitle={subtitle} />
          {children}
        </ContentContainer>
      </ResponsiveScrollView>
    </ScreenContainer>
  )
}

export default OnboardingScreen
